enum BookingStatus {
  NEW = 1,
  ACCEPTED = 2,
  REJECTED = 3,
  REMOVED = 4,
}

export default BookingStatus;
